module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }), _c('h2', {
    staticClass: "chapterNumber"
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/icemaidenthe_con01#ch_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("I blew into the newsroom in a hurry. My editors were impatient to hear more about Gomez and my story for tomorrow’s paper.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“They charged the poor guy with second-degree murder,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“As well they should,” Tubbs said righteously. He and Gretchen Platt, the assistant city editor from hell, exchanged glances across the city desk. “Take the law into your own hands and you face the consequences.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gretchen pursed her cotton-candy-pink lips, nodding so vigorously that her perfectly cut shiny-blond hair bounced in agreement.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To them the story was simple black and white. But unlike so many who commute to this fortresslike tower high above the city’s steamy streets and siren sounds and drive off at day’s end in their air-conditioned co"), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("coons to gated suburban communities a thousand light-years away, I see shades of gray every day.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("I went back to my desk, unable to forget the hopeless look on Gomez’s weary face. Sometimes you know at once when a victim will stay with you.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I wondered about the dead man. Medics say that someone who’s electrocuted remains conscious for at least fifteen seconds. Enough time to contemplate one’s life.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Whatever his past, it would be sad. They always are. The world is full of sadness. Life, like history, is just one damn thing after another. But no childhood hardship could mitigate the evil of what had happened to Ricky Chance and Sunny Hartley.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("What a great story it would be if Miami Detective Sergeant Craig Burch solved the crime at long last, suddenly positioned by fate to achieve justice in a case that had haunted him for years. Seek and ye shall find, I thought, tapping out the Gomez piece at my terminal—if you can just live long enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Miami’s mayor was “unavailable” for comment on Gomez’s pleas for help. His Honor was mired in his own soap-opera hell at the moment. Most couples war over sex, money, or in-laws, but when the mayor and his wife skirmished at breakfast over the proper way to brew a cup of tea, the press and the police had reacted as though he were O.J. on a rampage. SWAT sped to the scene, the house was cordoned off, cameramen and reporters ringed the house, news vans blocked the streets, and TV news choppers circled overhead. He blamed his political enemies, among them the police, with whom he had feuded over little Elián.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Elián and Fidel are no longer the chief topics debated over Cuban coffee. Many Miamians who have blamed Fidel for all things "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("malas")]), _vm._v(" in the world and flown only the Cuban flag for more than thirty years have become fiercely patriotic. Most men and women who crowded recruitment centers to enlist after the attacks on America were not born in this country. Many were in their fifties and sixties, willing but ineligible. The tiny flags they wave from Little Havana street corners are a heartening sight, despite the fact that upon closer inspection they are stamped "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("MADE IN TAIWAN")]), _vm._v(". It is a giant step forward. Sometimes only great tragedy creates unity.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The mayor’s secretary fished the shopkeeper’s most recent plea from a file labeled "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NON-URGENT")]), _vm._v(". Police record keepers also found a history of Gomez’s complaints. I reported them in my story for the street edition, along with the fact that, if convicted, he faced a possible sentence of life in prison.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I combed my hair and dabbed on fresh lipstick after deadline, then hurried down the long gray hall, past photo and the wire room, to pitch my Cold Case Squad idea to Spencer Morganstern, the editor of the paper’s recently revamped Sunday magazine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hot Topics")]), _vm._v(".")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("Morganstern, a small dapper man who favors vests and bow ties, is famous for his creativity and his short attention span. He waved me to a seat amid haphazard stacks of books, files, and newspapers on the leather couch in his glass cage, leaned back in his creaky leather chair, and studied me quizzically through owlish spectacles too big for his face. His unruly Einstein-like hair bristled in every direction, as though ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("electrified by the highly charged ideas, pictures, and possibilities that pervaded his mind, his office, and even the air around him.")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“The Cold Case Squad has a terrific cast of characters,” I said, launching my pitch. “Good detectives, hand-picked self-starters. They have to be, because they don’t get to experience the screams, the blood, or the sense of outrage cops feel at fresh murder scenes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Morganstern, expression bemused, did not react.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What drives them is that, unlike other crimes, first-degree murder has no statute of limitations. No matter how old the case, a killer can still be brought to justice.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Morganstern broke eye contact, frowning at a sheet of paper on his desk. My heart sank. Was he already bored?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ve known Burch since I first covered the beat,” I said, voice rising. “Sam Stone, one of the detectives, is an edgy, really sharp young black guy who grew up here, in Overtown. And Nazario was a Pedro Pan kid, one of thousands spirited out of Cuba at the dawn of Castro’s regime. The children were airlifted to freedom in Miami. The parents planned to follow but became trapped on the island when Fidel canceled the flights. Nazario arrived alone in Miami at age five. There are a couple of others: Corso, the guy wounded in that bank robbery a couple of years ago, and Acosta, who went on the cross-country gravedigging trip with that serial killer who confessed a few years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Their new lieutenant,” I said, rushing on, “is K. C. Riley. She used to command the Rape Squad.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("Morganstern continued to squint at the paper, which ")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("looked suspiciously like an expense account form, then reached for a red grease pencil.")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“The team’s on a roll,” I said, dropping my voice to a confidential tone. “About to tackle another really high-profile old case.” He was vigorously crossing out and circling items on the paper. “Their work is dramatic, like time travel. They go back in time to apply new high-tech Star Wars technology—lasers, computers, DNA, and blood-spatter analysis—to murders committed long before such forensic techniques were even dreamed of.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Everybody loves a mystery, and every one of their cases is a fascinating story in itself,” I said, beginning to wind down. “They found the killer in one case but made no arrest. His last address was a cemetery. He’d been there for two years: natural causes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Morganstern scowled, crumpled the paper, tossed it into his overflowing wastepaper basket, and looked up, as though puzzled to see me still there.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Will their bosses cooperate, give you access?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure,” I said quickly. “The department has had so much bad press that the brass will be thrilled about a piece on something positive.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The ring of confidence in my words struck an uneasy chord. My pitch for the story made sense, but cops often don’t. Police-press relationships are love-hate at best. Lieutenant Riley was notoriously reserved and tight-lipped with reporters. But I babbled on, despite my misgivings, determined to sell Morganstern the idea.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("“With so much bad news lately, readers will love the fact that murder victims are not forgotten, even years ")]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("later. That maybe a bad guy didn’t get away with murder after all, that not only does justice still exist in the world, it may prevail.”")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Better late,” Morganstern said, raising an eyebrow, “than never.” His phone rang, but he ignored it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Time changes people and circumstances,” I went on. “Sometimes all it takes to solve an old case is a few phone calls. Somebody afraid to tell the truth years ago feels free to do so now. The detectives dig up dusty evidence, blitz aging witnesses, travel to track them down, consult with forensic…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Enough.” Morganstern pointed his red grease pencil at me like a weapon. “Don’t push it. I was hooked when you said Cold Case Squad. That’s catchy.” He nodded and leaned back, contemplating the ceiling. “I’m thinking that for cover art, we can get these guys—and what’s-er-name, that woman lieutenant with the initials—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“K. C. Riley.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Right. Over to the Miami Ice Company. Yeah. Miami Ice Company. Dress ’em all up in business suits, sit them on giant blocks of ice, their jackets open, to expose their guns in shoulder holsters, in front of a sign that says "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("MIAMI ICE HOUSE")]), _vm._v(". You know, Cold Case Squad: Miami Ice?” He lurched forward in his chair. “Whaddaya think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well,” I murmured, appalled at the prospect of personally suggesting such an idea to Riley, “we’ll need a really first-rate photographer. Lottie is good with cops.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("Lottie Dane, my best friend, with her honeyed Texas drawl, reckless appeal, and flaming red hair, can per")]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("suade almost anybody to do almost anything in front of her cameras. Would her down-home charm work on the lieutenant?")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“You’re right about Lottie.” Morganstern stroked his thick mustache. “We’ll need photos of victims, perps, crime scenes. A shot of that dead killer’s tombstone. We can crop it like a mug shot. Whatever. You know the drill. About time you wrote something for us, Britt,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I left his office both elated and apprehensive. Now I would have to deliver.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("I left Lottie a heads-up on her answering machine.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Half a dozen Miami police press releases cluttered my e-mail, including a routine two-line PIO yawner on the gunshot victim I’d seen in the morgue. No mention of chicken feathers or glitter. The shooting, it said, was the result of a “prior dispute.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I beeped Alan Curlette, aka Spiffy, identified as the lead detective. Spiffy, a fastidious and dapper dresser, always stepped gingerly around crime scenes, careful not to get blood, brains, or body fluids on his Guccis. “Hey,” I asked, when he returned my call, “how come you never mentioned what the dead guy was and wasn’t wearing?”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("“Nobody asked,” he said sullenly. “I’m still trying to get all that damn stupid shit off of me. All I did was roll the guy over. Now I got little sparkles in my cuffs, on my shoes, in my socks. I go to scratch my head, I see sparkles on my elbow. Is it unreasonable for me to be pissed off that there is glitter all over my goddamn car? ")]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("What’s more, it don’t work. Unfortunately, my goddamn sergeant can still see me.”")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Probably because you’re dressed,” I said. “I think you’re supposed to be naked for the full effect.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“How would you know what I happen to be wearing or not wearing?” he asked slyly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Somehow, I have a feeling that you’re not sitting at your desk in the homicide bureau with no pants on,” I said. “Don’t ask me why. It’s just some sort of sixth sense. Maybe I’m psychic.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Or psycho. You Cubans are nuts.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Somebody should sue this guy’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("santero")]), _vm._v(" for malpractice.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He said witnesses told him the victim never even tried to escape his killer. Instead, convinced he was invisible, he flaunted his naked body, grinning and making rude gestures at the gunman. Imagine his surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Resolving always to ask how all parties to fatal confrontations were dressed—or not—I wrote the story, turned it in, and then called the M.E. office. The scarred man had been fingerprinted. We should know his identity soon.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A Cold Case Squad detective came by, had quite an interest in this fellow,” the chief said mildly. “By the way, I’ve been thinking about his scars. His burns may have been caused by potash.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Potash?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Haven’t seen a case in years, but potash burns used to be quite common in poorer communities, back before guns became so cheap and readily available.”")])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Folks used to mix lye, cooking grease, and hot water to make soap. Potash is an old term for the alkaline material used in soap. People buy guns for defense today, but back then lye was the weapon of choice in domestic and neighborhood brawls. Anybody who expected trouble would keep a can of lye behind the door or next to the bed. We’ll find out when we learn more about his medical history.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So you think he might be older than he looks?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No, but he may have come from a rural area where people still clung to the old ways.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("I began to put notes together on the Cold Case Squad and asked Onnie, who works in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("News")]), _vm._v(" library, for our photo files on Richard Chance and Sunny Hartley.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She brought them out herself a short time later. No longer stick-thin, Onnie is simply slim, even shapely, having gained enough weight to soften the structure of her angular bones. Her simple white blouse contrasted dramatically with her coffee-color skin and short curly hair. In no way did she resemble the desperate, battered young mother I first met. Her son, Darryl, now six, is a survivor like his mom. She is divorced now, her violent ex-husband serving a long prison sentence for an attack on a police officer, among other things.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Plenty here on the boy.” Onnie perched on the corner of my desk, opened a manila folder, and studied a photo. “But nothing,” she added, bright black eyes meeting mine, “on the girl you mentioned.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("Of course, I realized. The names and photos of rape ")]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_vm._v("victims go unpublished. Sunny’s name and face had never appeared in news accounts of the tragedy.")])]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Onnie handed me the folder. Fair hair neatly combed, Richard Lee Chance wore a serious expression in his high school yearbook photo, though his eyes hinted at a subdued mirth. In another picture he knelt on one knee at the forefront of his exuberant varsity basketball team after a winning season.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Snapshots of his short and happy life contrasted starkly with news photos of grim men lifting his covered corpse to load into the morgue wagon. He had been found face up, surrounded by ripening tomato plants that thrived in that fertile farm field. His body had remained on the scene, the caption said, for more than eight hours, as detectives and crime scene technicians painstakingly did their work.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Unsolved,” Onnie said breezily. “No stories on it for years. Is there something new?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Could be.” I tapped into the library’s computer files. “Let’s hope.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There had been dozens of stories. Ricky was the only child of Sean Chance, a city planner, and his wife, Heather, who taught school at Millard Junior High. High school students wept and clung to one another at the boy’s funeral. Hundreds filled the church, spilling into the street, as Ricky’s basketball coach and his pastor delivered eulogies. The family was too distraught to speak.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_vm._v("The wounded girl’s parents kept a hospital vigil, their daughter not expected to survive. After ten days, however, her prognosis changed, her condition up")]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_vm._v("graded from critical to serious, then from serious to fair. Police guarded her room, and as soon as she was able, she cooperated with detectives as best she could.")])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("My phone rang while I was still reading. “Got an ID.” Burch sounded upbeat. “Andre Coney, age thirty-one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“His rap sheet?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Dates back to age eleven, mostly petty but some strong-arms, a lotta B and E’s, drugs, one lewd and lascivious.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Was he married? Who did he live with? Parents?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“According to Levitan, the next of kin’s an aunt, one Ida Sweeting in South Miami. She helped raise him. But when he made the notification, she said she wasn’t even sure where he’d been staying. Hadn’t seen him in weeks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Think she’ll remember who he ran with fourteen years ago?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hope so, but I gotta do the drill before I talk to her. The team’s gonna meet in the "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.M.")]), _vm._v(", eyeball the file, then vote on whether to take on the case. Only a formality. Everybody’s hot to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What about Sunny, she still local?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yeah, made a coupla calls. Lives over on the beach now. I’ll look her up tomorrow after the meeting. Meanwhile, if you put Coney’s name in the paper, don’t mention a connection to this case.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Right. Think Sunny will talk to me too?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s up to her,” he said. “Just don’t jump the gun on me. Sit on it until I show her some pictures. I’m digging up Coney’s old mug shots from back then.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  })]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Biscayne Bay glinted like broken glass beneath the slanting rays of the late-afternoon sun, as I drove home. No tourist would suspect that beneath its postcard-perfect surface, the bay had become a toilet that couldn’t be flushed. Underwater sewer lines had ruptured and water-use restrictions had complicated matters. Power cleaning, car washing, and bubbling fountains had been outlawed. Police were enforcing the bans and Miamians had been warned to limit washing clothes and dishes and to flush only when necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The future seemed grim and increasingly brown. What has happened to the world, to this city, and to me? I wondered, trying unsuccessfully to block out Kendall McDonald, who lingered in my heart and mind like a melancholy refrain. Uneasy and restless, shadowed by a vague foreboding, I yearned to flee, to roam uncharted shores and unspoiled beaches. This "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hot Topics")]), _vm._v(" story, I thought, would finance my brief escape.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There were other benefits as well. Having time to polish a magazine piece is a luxury to those of us who pound out daily news stories. My work wouldn’t be mindlessly slashed by an uncaring editor under deadline pressure or forced out of the paper by late-breaking news. This project was something to look forward to in an uncertain world.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mrs. Goldstein, my landlady, was in her garden, lugging a plastic water bucket that sloshed with each step.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m watering,” she explained, “with gray water.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray is the term for water discarded after bathing or washing dishes.")])]), _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Bathwater,” she panted, wisps of gray hair clinging to her neck, her cotton housedress damp with perspiration.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You can’t do this,” I protested. The woman is eighty-two years old.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But look.” She gestured, a smile lighting up her face.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Brunfelsia’s pale lavender flowers exuded a heady fragrance. The same delicate blooms were deep purple yesterday. Tomorrow they would fade to white, then fall, like young lives cut short. The wistful beauty of the fragrant flowering shrub, common name Yesterday, Today, and Tomorrow, was worth any effort.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I fetched my own pail. Bitsy, my police-trained tiny mop of a dog, scampered around us as we launched a bucket brigade from the Goldstein bathtub to her garden, pausing only to curse state water managers. Our sea-level city drowned last fall. Homes and cars flooded, sewers backed up, and hapless motorists drowned, their cars submerged after they mistook overflowing canals for flooded streets. State officials reacted by reducing the water levels in Lake Okeechobee—the Native American word for Big Water—far too much. The huge freshwater lake, second largest in the lower forty-eight states, supplies South Florida’s drinking water. Now this lake, the planet’s most recognizable feature when viewed from outer space, was nearly dry and we faced another water crisis. This time, too little.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I fed Bitsy and Billy Boots the cat, surveyed the unappealing prospects in my refrigerator, and checked my messages. Only one.")])]), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("I called her back. “You’re running with the Cold Case Squad assignment, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure thang,” Lottie said. “Any of them bad boys single and hot to go?” Despite a dispiriting string of Mr. Wrongs, she is ever optimistic.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She insisted we celebrate our magazine assignment. So Bitsy and I took a quick walk, Billy Boots trailing at a distance, so he could pretend not to know us if we did something embarrassing. Then Lottie picked me up.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("We settled at an umbrella table between the pool and the docks at the Fifth Street Marina. Lottie, the paper’s best breaking-news shooter, bitched bitterly about the day’s assignments from Gretchen, all local politicians “presenting the plaque.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Isn’t this premature?” I asked Lottie, as I ordered a Painkiller Number One. The sneaky concoction of rum, coconut cream, pineapple, and orange juice is smooth and guaranteed to numb the senses. It’s available in various strengths, depending on the severity of your pain. “Shouldn’t we finish the project, then celebrate?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She ordered a lime margarita. “We kin party then too, and again when it’s published. Didn’t the President say we all should go back to our normal lives?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure. He also said, ‘Watch out, because we don’t know when or how but somebody’s trying to kill you. Now go on out there and live normally, but stay alert.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not bad advice whenever,” she said, “especially in Miami. I tell that to myself every time I get behind the wheel, especially when I drive the Palmetto Expressway. You ever been to Xochimilco, Mejico?”")])]), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“I wouldn’t even try to spell it, much less find it. What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Little town where they celebrate four hundred twenty-two official fiestas a year!” She wrinkled her freckled nose and grinned. “Them Mexicans sure know how to live.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Maybe there’s nothing to celebrate around here.” I sighed, watching night creep along the western horizon. “Lately, Lottie, especially after what happened in New York and DC, life feels like a long winter with no Christmas.” I told her about Sunny Hartley and Ricky Chance.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She shook her head at the terrible details. “Gonna talk to the poor little gal?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure. But Burch has to break the news first, find out if the dead guy really was one of her attackers. No point in me intruding on her if he wasn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“We’re gonna be working with Riley on the Cold Case gig,” Lottie said cheerfully. “Still suspect she and McDonald have the hots for each other?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I took a healthy swallow of my Painkiller and shrugged. “Nothing I can do about it if they do.” The lack of trust, the misunderstandings and regrets all came back to me. I stared in dismay at my drink. So far it wasn’t doing its job. “I don’t even know if he’s back from New York yet,” I said. “Haven’t heard a thing since he left with the contingent of Miami cops who volunteered for the assistance mission. Isn’t it strange that he’d find Riley attractive? You’d think she’d be the last woman he’d lust after. We’re nothing alike. She’s such an obnoxious bitch.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_vm._v("Lottie squinted and cupped her ear, as though she ")]), _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_vm._v("hadn’t heard right. “Sure. And you’re a real little Miss Congeniality, so shy and sweet.”")])]), _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“What do you mean?” I asked, incredulous. “Riley is a superbitch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And what are you like when some fool gets in your way on deadline?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("so")]), _vm._v(" different,” I said. “You do what you have to on deadline. All that matters is the story. So you do things you’d never do normally. You know how it is. The job gives you tunnel vision. But I’m not really like that, am I?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Then why do some people swear you have a tail and horns?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“How can you say that?” I snapped, irritated. “I’m in no mood—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What I’m saying,” she said earnestly, “is that K. C. Riley is probably a whole lot like you: tiger on the job, pussycat at heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Oh, puleeze.” I rolled my eyes in exasperation.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why not give McDonald a call when he gets home?” she said. “He’ll probably need lots of TLC after Ground Zero. Be sweet, check it out. Maybe nothing’s going on there. Maybe they’re buddies. You know cops. How they like to hang out with other cops, live in the same neighborhoods—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yeah, and they tend to intermarry. I never returned his last message,” I confessed glumly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She frowned. “You need a blood test,” she said, “to see if any is getting to your brain. I thought you and him were—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So did I, Lottie.” I sighed impatiently. “So did I.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_vm._v("“What about Fitzgerald?” she asked. Dennis Fitzger")]), _c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_vm._v("ald is an investigator for the Volusia County state attorney’s office, and we had hit it off when an old case brought him to Miami.")])]), _c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“A great guy,” I said, “but in Daytona Beach, three hundred miles away.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He’d be here in a heartbeat if you’d show a little interest.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“My heart just isn’t in it, Lottie.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mercifully, she changed the subject. “So this gal Sunny survived, but did she recover? Living a normal life?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I guess so,” I said uncertainly. “As if anybody could after what happened to her. You remember what sixteen was like. Everything was a big deal. A date for the school dance was a matter of life or death. She’s grown up now, must be twenty-nine or so. I wonder if she has a life, or just therapy three or four times a week.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“People are resilient,” Lottie said quietly, “especially kids. We see it all the time. Even close to home, look at little Darryl.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Right.” I couldn’t help smiling. “He couldn’t be better. In fact, Onnie gave me one of his new crayon drawings the other day. It’s on my refrigerator; I love it. I think he’s got a real talent, even though he’s only six.” I lifted my glass. “I hope Sunny’s life is happy. Maybe she’s married, with kids of her own. Strange, isn’t it, for us to be here, talking about her like this, knowing something she doesn’t?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Like what?”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_vm._v("“That even if she has put that terrible night behind ")]), _c('a', {
    attrs: {
      "id": "page53"
    }
  }, [_vm._v("her, it’s back. Nobody outlives the past.” We watched a quarter moon emerge in the darkening sky. “Wherever she is, whatever she’s doing, I wonder if she feels something in the air, senses that her life is about to change.”")])]), _c('a', {
    attrs: {
      "id": "page53"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“If that barbecued bandido was one of ’em, she’ll be happy to hear he’s on an elevator ride straight to hell and the rest of ’em may soon git what’s coming to ’em.” She smiled sweetly and winked back at a hunk at the bar.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("An apprehensive chill rippled up my spine. What was Sunny’s life really like? I wondered. How would she react to the news?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The man at the bar, a smiling sun-bronzed yachtsman named Brad, zeroed in on Lottie like a heat-seeking missile. He was eager to buy us drinks, dance with us to the island music, and whisk us away on a moonlight cruise. She was ready to go, but I wanted an early start in the morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Lottie gave Brad her phone number as he walked us back to her company car, still cajoling us to stay. As we rolled out of the parking lot, her dashboard police scanner crackled to life. Typical Miami night: shots fired in Wynnwood, a hit-run driver fleeing east in the westbound lanes of I-95, and an out-of-control fire at 224 Northwest 14th Street.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("My heart sank. I wanted another Painkiller. “Hear that, Lottie? Fourteenth Street. Let’s go.” I fastened my seat belt.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Only one engine company so far,” she protested. “Don’t sound big to me.”")])]), _c('a', {
    attrs: {
      "id": "page54"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s big,” I said, a bitter taste in my mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She shrugged, stomped the gas, burned rubber in a U-turn, and we streaked west.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Dammit.” I locked the scanner onto Miami’s fire frequency. “Hear that? Fully involved, out of control.” I groped in my purse for a notebook. “You got your camera gear?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“’Course, in the trunk.” The eight-cylinder engine whined as she swerved around a slow-moving jitney and floored it. She pouted. “Thought you was dead set on gettin’ to bed early.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I was,” I said somberly, “but now I need to get back over there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Over where?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Gomez Watch Repair.”")])])]), _c('a', {
    attrs: {
      "id": "page54"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page54"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e6a13d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icemaidenthe_ch02.vue
// module id = 75
// module chunks = 0